import { render, staticRenderFns } from "./OnsiteCustomer.vue?vue&type=template&id=7911c604&scoped=true"
import script from "./OnsiteCustomer.vue?vue&type=script&lang=js"
export * from "./OnsiteCustomer.vue?vue&type=script&lang=js"
import style0 from "./OnsiteCustomer.vue?vue&type=style&index=0&id=7911c604&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7911c604",
  null
  
)

export default component.exports